import './index.scss';
import BeaconFooter from '../../BeaconFooter';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { InformaFooterComponent } from './InformaFooter/InformaFooterComponent';

export default function Footer() {
	const isMobileFilterOpen = useSelector(
		(state: RootState) => state.appState.filterState?.isMobileFilterOpen
	);
	const { isLoadingData, errorState } = useSelector((state: RootState) => state.appState);
	return (
		<>
			{!isMobileFilterOpen && (
				<div data-testid='footer' className='footer'>
					<BeaconFooter isLoadingData={isLoadingData} hasError={errorState?.hasError} />
					<InformaFooterComponent />
				</div>
			)}
		</>
	);
}
